// 引入拖拽js
import { startDrag } from "@/utils/drag.js";

/**
 * 为el-dialog弹框增加拖拽功能
 * @param {*} el 指定dom
 * @param {*} binding 绑定对象
 * desc   只要用到了el-dialog的组件，都可以通过增加v-draggable属性变为可拖拽的弹框
 */
const draggable = {
  mounted(el, binding) {
    try {
      // 等待DOM更新完成
      setTimeout(() => {
        const dialog = el.classList && el.classList.contains("el-dialog")
          ? el
          : el.closest(".el-dialog") || el.querySelector(".el-dialog");
        const header = dialog ? dialog.querySelector(".el-dialog__header") : null;
        
        if (header && dialog) {
          el._cleanupDrag = startDrag(header, dialog, binding.value);
        } else {
          console.warn('拖拽指令: 未找到弹框元素');
        }
      }, 0);
    } catch (error) {
      console.error('拖拽指令错误:', error);
    }
  },
  unmounted(el) {
    if (typeof el._cleanupDrag === "function") {
      el._cleanupDrag();
      delete el._cleanupDrag;
    }
  }
};

const directives = {
  draggable,
};

// Vue 3 插件安装方法
export default {
  install(app) {
    Object.keys(directives).forEach((key) => {
      app.directive(key, directives[key]);
    });
  },
};